var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSolar)?_c('feather-icon',{attrs:{"color":_vm.klor,"icon":"SunIcon","size":"24"}}):_c('feather-icon',{attrs:{"color":"orange","icon":"MoonIcon","size":"24"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }